import React, { useState, useEffect, useRef } from 'react';
import HeaderMainPage, { newCampaign } from '../../header/HeaderMainPage';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { IoArrowBack } from "react-icons/io5";
import CampaignSummary from "./campaignSummary";
import { HiDotsVertical } from "react-icons/hi";

const StarIcon = ({ filled }) => (
  <svg className={`w-5 h-5 ${filled ? 'text-yellow-400' : 'text-gray-300'}`} fill="currentColor" viewBox="0 0 20 20">
    <path d="M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z" />
  </svg>
);

// Optional: a tiny badge for numbers
const StatBadge = ({ children, tone = "gray" }) => {
  const tones = {
    gray: "bg-gray-100 text-gray-700 ring-gray-200",
    green: "bg-emerald-50 text-emerald-700 ring-emerald-200",
    blue: "bg-blue-50 text-blue-700 ring-blue-200",
    yellow: "bg-amber-50 text-amber-700 ring-amber-200",
    red: "bg-red-50 text-red-700 ring-red-200",
  };
  return (
    <span className={`inline-flex items-center justify-center px-2.5 h-7 rounded-full text-xs font-medium ring-1 ${tones[tone]}`}>
      {children}
    </span>
  );
};

// Define (kept for possible future use)
const columnWidths = {
  checkbox: '50px',
  star: '50px',
  campaign: '300px',
  deliveryDate: '150px',
  coreproduct: '150px',
  actions: '100px',
  value: '100px',
};
const CampaignTableSkeleton = ({ rows = 6 }) => {
  return (
    <>
      {Array.from({ length: rows }).map((_, idx) => (
        <tr key={idx} className="animate-pulse">
          <td className="px-2">
            <div className="h-4 w-4 bg-gray-200 rounded" />
          </td>

          <td className="px-2">
            <div className="h-4 w-4 bg-gray-200 rounded-full" />
          </td>

          <td className="px-4 py-3">
            <div className="h-4 bg-gray-200 rounded w-3/4 mb-2" />
            <div className="h-3 bg-gray-100 rounded w-1/2" />
          </td>

          <td className="px-4 py-3">
            <div className="h-4 bg-gray-200 rounded w-24" />
          </td>

          <td className="px-4 py-3">
            <div className="h-4 bg-gray-200 rounded w-40" />
          </td>

          {Array.from({ length: 5 }).map((_, i) => (
            <td key={i} className="px-4 py-3 text-center">
              <div className="h-6 w-10 mx-auto bg-gray-200 rounded-full" />
            </td>
          ))}

          <td className="px-2">
            <div className="h-5 w-5 bg-gray-200 rounded" />
          </td>
        </tr>
      ))}
    </>
  );
};
const CampaignMobileSkeleton = ({ items = 4 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: items }).map((_, idx) => (
        <div
          key={idx}
          className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm animate-pulse"
        >
          <div className="flex items-start justify-between mb-2">
            <div className="flex items-start gap-3">
              <div className="h-4 w-4 bg-gray-200 rounded" />
              <div>
                <div className="h-4 bg-gray-200 rounded w-48 mb-2" />
                <div className="h-3 bg-gray-100 rounded w-32" />
              </div>
            </div>

            <div className="h-5 w-5 bg-gray-200 rounded" />
          </div>

          <div className="flex flex-wrap gap-2 mt-4">
            {["Prospects", "Sent", "Open", "Reply", "Interested"].map(
              (_, i) => (
                <div
                  key={i}
                  className="flex flex-col items-center justify-center w-[64px] h-[44px] bg-gray-100 rounded-full"
                >
                  <div className="h-4 w-6 bg-gray-200 rounded mb-1" />
                  <div className="h-2 w-10 bg-gray-200 rounded" />
                </div>
              )
            )}
          </div>
        </div>
      ))}
    </div>
  );
};



const MyCampaign = () => {
  const navigate = useNavigate();
  const [campaigns, setCampaigns] = useState([]);
  const [activeTab, setActiveTab] = useState('All');
  const [searchTerm, setSearchTerm] = useState('');
  const [selectAll, setSelectAll] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(null);
  const [anySelected, setAnySelected] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [IsLoading,setIsLoading]=useState(true);

  const roboman_api = process.env.REACT_APP_ROBOMAN_API;
  const campaignSelectionRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (campaignSelectionRef.current && !campaignSelectionRef.current.contains(event.target)) {
        setOpenDropdown(null);
      }
    };
    const handleScroll = () => setOpenDropdown(null);
    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener("wheel", handleScroll);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener("wheel", handleScroll);
    };
  }, []);

  const updateColumnWidth = (column, width) => {
    columnWidths[column] = width;
    setCampaigns([...campaigns]);
  };

  const fetchCampaignDataFromAPI = async (access_token) => {
    try {
      const response = await fetch(`${roboman_api}/campaign/personal`, {
        method: 'GET',
        headers: { 'Content-Type': 'application/json', 'Authorization': access_token },
      });
      if (!response.ok) {
        console.error(`HTTP error! status: ${response.status}`);
        return [];
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Error fetching user campaign data:', error);
      return null;
    }
    finally{
      setIsLoading(false);
    }
  };

  const formatDate = (dateString) => {
    const date = new Date(dateString);
    const time = date.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
    const formattedDate = date.toLocaleDateString('en-US', { month: '2-digit', day: '2-digit', year: 'numeric' });
    return `${time} ${formattedDate}`;
  };

  const fetchCampaignData = async () => {
    const access_token = localStorage.getItem('access_token');
    const userCampaign = await fetchCampaignDataFromAPI(access_token);
    if (userCampaign) {
      const staticCampaigns = userCampaign.map((item) => ({
        id: item.campaign_id,
        name: item.campaign_name,
        deliveryDate: formatDate(item.created_at),
        isStarred: false,
        isSelected: false,
        campaigns_id: item.campaign_id,
        campaigns_info: item.campaign_info,
        email_format_info: item.email_format,
        must_have_info: item.campaign_contact?.campaign_email || "",
        stats: item.stats
      }));
      setCampaigns(staticCampaigns);
    }
  };

  useEffect(() => { fetchCampaignData(); }, []);

  const handleTabClick = (tab) => setActiveTab(tab);

  const handleStarClick = (id) => {
    setCampaigns(campaigns.map(campaign =>
      campaign.id === id ? { ...campaign, isStarred: !campaign.isStarred } : campaign
    ));
  };

  const handleSelectAll = () => {
    setSelectAll(!selectAll);
    setCampaigns(campaigns.map(c => ({ ...c, isSelected: !selectAll })));
    setAnySelected(!selectAll);
  };

  const handleSearch = (e) => setSearchTerm(e.target.value);

  const handleDelete = async (id) => {
    try {
      const response = await fetch(`${roboman_api}/campaign/${id}/delete`, {
        method: 'DELETE',
        headers: { 'accept': 'application/json', 'Authorization': localStorage.getItem('access_token') },
      });
      if (!response.ok) {
        console.error('Failed to delete campaign', response);
        Swal.fire({ icon: 'error', title: 'Error!', text: 'There was a problem deleting the campaign. Please try again later.', confirmButtonText: 'OK' });
        return;
      }
      setCampaigns(campaigns.filter(c => c.id !== id));
      Swal.fire({ icon: 'success', title: 'Deleted!', text: 'Your campaign has been deleted successfully.', confirmButtonText: 'OK' });
    } catch (error) {
      console.error('Error deleting campaign:', error);
      Swal.fire({ icon: 'error', title: 'Error!', text: 'There was a problem deleting the campaign. Please try again later.', confirmButtonText: 'OK' });
    }
    setOpenDropdown(null);
  };

  const handleDetails = (campaign) => {
    localStorage.setItem('campaign_name', campaign.name);
    localStorage.setItem('campaign_id', campaign.id);
    navigate(`/email-status`);
  };

  const handleCheckboxChange = (id) => {
    setCampaigns(campaigns.map(c =>
      c.id === id ? { ...c, isSelected: !c.isSelected } : c
    ));
    const newAnySelected = campaigns.some(c => c.id === id ? !c.isSelected : c.isSelected);
    setAnySelected(newAnySelected);
  };

  const handleDeleteSelected = async () => {
    const campaign_delete_list_id = campaigns.filter(c => c.isSelected).map(c => c.id);
    if (campaign_delete_list_id.length === 0) {
      Swal.fire({ icon: 'warning', title: 'No Campaigns Selected', text: 'Please select at least one campaign to delete.' });
      return;
    }
    try {
      Swal.fire({ title: 'Deleting Campaigns...', text: 'Please wait while the selected campaigns are being deleted.', allowOutsideClick: false, didOpen: () => Swal.showLoading() });
      for (let i = 0; i < campaign_delete_list_id.length; i++) {
        try {
          const response = await fetch(`${roboman_api}/campaign/${campaign_delete_list_id[i]}/delete`, {
            method: 'DELETE',
            headers: { accept: 'application/json', Authorization: localStorage.getItem('access_token') },
          });
          if (!response.ok) console.error('Failed to delete campaign', response);
        } catch (error) {
          console.error('Error deleting campaign:', error);
        }
        await new Promise((resolve) => setTimeout(resolve, 1000));
      }
      Swal.fire({ icon: 'success', title: 'Deleted!', text: 'Selected campaigns have been deleted successfully.' });
    } catch (error) {
      console.error('Error during deletion process:', error);
      Swal.fire({ icon: 'error', title: 'Error!', text: 'There was a problem deleting the campaigns. Please try again later.' });
    }
    await fetchCampaignData();
  };

  const handleBack = () => navigate('/dashboard');

  const filteredCampaigns = campaigns
    .filter(c => (activeTab === 'All') ? true : c.isStarred)
    .filter(c =>
      (c.name && c.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
      (c.library && c.library.toLowerCase().includes(searchTerm.toLowerCase()))
    );

  const [dropdownPosition, setDropdownPosition] = useState({ top: 0, left: 0 });
  const handleDropdownToggle = (campaignId, event) => {
    if (openDropdown === campaignId) {
      setOpenDropdown(null);
    } else {
      const rect = event.currentTarget.getBoundingClientRect();
      setDropdownPosition({ top: rect.bottom + window.scrollY + 8, left: rect.left + window.scrollX - 120 });
      setOpenDropdown(campaignId);
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen">
      <HeaderMainPage />

      <div className="max-w-7xl mx-auto px-6 lg:px-8 mt-20">
        {/* Page header */}
        <div className="bg-white border border-gray-200 shadow-sm rounded-2xl p-5 md:p-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 mb-6">
          <div className="flex items-center gap-3">
            <button
              onClick={handleBack}
              className="inline-flex items-center justify-center h-10 w-10 rounded-full bg-gray-100 hover:bg-gray-200 text-gray-700 transition"
              aria-label="Back"
            >
              <IoArrowBack size={18} />
            </button>
            <div>
              <h1 className="text-xl md:text-2xl font-extrabold text-gray-900 tracking-tight">Campaigns</h1>
              <p className="text-xs text-gray-500 mt-0.5">Manage and track your outreach campaigns</p>
            </div>
          </div>

          <button
            onClick={() => newCampaign(navigate)}
            className="inline-flex items-center justify-center h-11 px-5 rounded-full bg-gradient-to-r  from-indigo-600  via-violet-600 to-fuchsia-600  text-white font-semibold shadow-sm hover:from-violet-600 hover:to-indigo-600 transition"
          >
            + New Campaign
          </button>
        </div>

        {/* Tabs */}
        <div className="flex items-center gap-2 mb-4">
          {['All', 'Important'].map(tab => (
            <button
              key={tab}
              onClick={() => handleTabClick(tab)}
              className={`h-9 px-4 rounded-full text-sm font-medium transition
                ${activeTab === tab
                  ? 'bg-gradient-to-r  from-indigo-600 via-violet-600  to-fuchsia-600   text-white shadow-sm'
                  : 'bg-white text-gray-700 border border-gray-200 hover:bg-gray-50'}`}
            >
              {tab}
            </button>
          ))}
        </div>

        {/* Toolbar */}
        <div className="bg-white border border-gray-200 rounded-xl p-3.5 flex flex-col md:flex-row md:items-center md:justify-between gap-3 mb-5">
          <div className="flex items-center gap-3">
            <input
              type="checkbox"
              checked={selectAll}
              onChange={handleSelectAll}
              className="h-5 w-5 text-blue-600 border-gray-300 rounded focus:ring-blue-500"
            />
            <div className="relative">
              <input
                type="text"
                placeholder="Search campaigns..."
                value={searchTerm}
                onChange={handleSearch}
                className="w-[260px sm:w-[320px w-full pl-10 pr-4 py-2 text-sm border border-gray-300 rounded-xl shadow-sm focus:ring-2 focus:ring-blue-500 focus:outline-none"
              />
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <svg className="h-5 w-5 text-gray-400" viewBox="0 0 20 20" fill="currentColor">
                  <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
                </svg>
              </div>
            </div>
          </div>

          {/* Bulk actions appear when something is selected */}
          <div className="flex items-center gap-2">
            <button
              className={`h-9 px-4 rounded-xl text-sm font-semibold transition
                ${anySelected
                  ? 'bg-red-600 text-white hover:bg-red-700'
                  : 'bg-gray-100 text-gray-400 cursor-not-allowed'}`}
              onClick={handleDeleteSelected}
              disabled={!anySelected}
            >
              Delete Selected
            </button>
          </div>
        </div>

        {/* Table */}
        <div className="hidden md:block bg-white border border-gray-200 shadow-sm rounded-2xl overflow-hidden mb-4">
          <div className="max-h-[70vh] overflow-auto">
            <table className="min-w-full text-sm">
              <thead className="bg-gray-50 sticky top-0 z-10 border-b border-gray-200">
                <tr className="text-gray-600">
                  <th className="w-10"></th>
                  <th className="w-10"></th>
                  <th className="px-4 py-3 text-left font-semibold">Campaign</th>
                  <th className="px-4 py-3 text-left font-semibold">Created</th>
                  <th className="px-4 py-3 text-left font-semibold">Core Product</th>
                  <th className="px-4 py-3 text-center font-semibold">Prospects</th>
                  <th className="px-4 py-3 text-center font-semibold">Sent</th>
                  <th className="px-4 py-3 text-center font-semibold">Open</th>
                  <th className="px-4 py-3 text-center font-semibold">Reply</th>
                  <th className="px-4 py-3 text-center font-semibold">Interested</th>
                  <th className="w-10"></th>
                </tr>
              </thead>

              <tbody className="divide-y divide-gray-100">
                {IsLoading?
                (<CampaignTableSkeleton row={7}/>)
                :
                ((filteredCampaigns?.length === 0) ? (
                  <tr>
                    <td colSpan="11" className="px-6 py-16 text-center">
                      <div className="mx-auto w-full max-w-md">
                        <div className="text-2xl font-semibold text-gray-800 mb-1">No campaigns yet</div>
                        <p className="text-gray-500 mb-4">Create a campaign to start your outreach.</p>
                        <button
                          onClick={() => newCampaign(navigate)}
                          className="inline-flex items-center justify-center h-10 px-4 rounded-full bg-gradient-to-r from-indigo-600 via-to-violet-600 to-fuchsia-600 text-white font-semibold hover:bg-blue-700"
                        >
                          + New Campaign
                        </button>
                      </div>
                    </td>
                  </tr>
                ) : (
                  filteredCampaigns.map(campaign => (
                    <tr key={campaign.id} className="hover:bg-gray-50 transition">
                      <td className="px-2">
                        <input
                          type="checkbox"
                          checked={campaign.isSelected}
                          onChange={() => handleCheckboxChange(campaign.id)}
                          className="h-4 w-4 text-blue-600 border-gray-300 rounded"
                        />
                      </td>

                      <td className="px-2">
                        <button onClick={() => handleStarClick(campaign.id)} className="focus:outline-none">
                          <StarIcon filled={campaign.isStarred} />
                        </button>
                      </td>
                      <td className="px-4 py-3">
                        <button
                          onClick={() => handleDetails(campaign)}
                          className="text-gray-900 font-medium text-start hover:text-blue-600 truncat line-clamp-2 hover:underline underline-offset-2"
                          title={campaign.name}
                        >
                          {campaign.name}
                        </button>
                        {campaign.library && (
                          <div className="text-xs text-gray-500 mt-0.5">{campaign.library}</div>
                        )}
                      </td>

                      <td className="px-4 py-3 text-gray-600">{campaign.deliveryDate}</td>

                      <td className="px-4 py-3 text-gray-600 truncate max-w-xs" title={campaign.campaigns_info.core_service}>
                        {campaign.campaigns_info.core_service}
                      </td>

                      <td className="px-4 py-3 text-center">
                        <StatBadge tone="gray">{campaign.stats.prospects_count}</StatBadge>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatBadge tone="blue">{campaign.stats.sent.count}</StatBadge>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatBadge tone="yellow">{campaign.stats.opened.count}</StatBadge>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatBadge tone="green">{campaign.stats.replied.count}</StatBadge>
                      </td>
                      <td className="px-4 py-3 text-center">
                        <StatBadge tone="green">{campaign.stats.interested.count}</StatBadge>
                      </td>

                      <td className="px-2 text-center" ref={campaignSelectionRef}>
                        <button
                          onClick={(e) => handleDropdownToggle(campaign.id, e)}
                          className="text-gray-400 hover:text-gray-600 rounded p-1"
                          aria-label="More actions"
                        >
                          <HiDotsVertical className="w-5 h-5" />
                        </button>
                      </td>
                    </tr>
                  ))
                ))}
             
              </tbody>
            </table>
          </div>
        </div>

        {/* Mobile Cards for table data*/}
        <div className="md:hidden space-y-4 mb-6">

          {IsLoading?
          (<CampaignMobileSkeleton/>)
          :
           ((filteredCampaigns?.length === 0) ? (
                  <tr>
                    <td colSpan="11" className="px-6 py-16 text-center">
                      <div className="mx-auto w-full max-w-md">
                        <div className="text-2xl font-semibold text-gray-800 mb-1">No campaigns yet</div>
                        <p className="text-gray-500 mb-4">Create a campaign to start your outreach.</p>
                        <button
                          onClick={() => newCampaign(navigate)}
                          className="inline-flex items-center justify-center h-10 px-4 rounded-full bg-gradient-to-r from-indigo-600 via-to-violet-600 to-fuchsia-600 text-white font-semibold hover:bg-blue-700"
                        >
                          + New Campaign
                        </button>
                      </div>
                    </td>
                  </tr>
                ):
          

          filteredCampaigns.map((campaign) => (
            <div
              key={campaign.id}
              className="bg-white border border-gray-200 rounded-xl p-4 shadow-sm"
            >
              {/* Header */}
              <div className="flex justify-between items-start">
                <div className="flex items-start gap-2 ">
                  <input
                    type="checkbox"
                    checked={campaign.isSelected}
                    onChange={() => handleCheckboxChange(campaign.id)}
                    className="mt-1 h-4 w-4 text-blue-600 border-gray-300 rounded"
                  />
                  <div>
                    <button
                      onClick={() => handleDetails(campaign)}
                      className="font-semibold text-gray-900 text-sm leading-snug hover:underline"
                    >
                      {campaign.name}
                    </button>
                    {/* <p className="text-xs text-gray-500 mt-0.5">
                      {campaign.deliveryDate}
                    </p> */}
                  </div>
                </div>

                <button
                  onClick={(e) => handleDropdownToggle(campaign.id, e)}
                  className="text-gray-400"
                >
                  <HiDotsVertical />
                </button>
              </div>

              {/* Core Product */}
              <p className="text-xs text-gray-600 mt-2 line-clamp-2">
                {campaign.campaigns_info.core_service}
              </p>

              {/* Stats */}
              <div className="grid grid-cols-5 gap-2 text-center mt-4">
                <StatBadge>{campaign.stats.prospects_count}</StatBadge>
                <StatBadge tone="blue">{campaign.stats.sent.count}</StatBadge>
                <StatBadge tone="yellow">{campaign.stats.opened.count}</StatBadge>
                <StatBadge tone="green">{campaign.stats.replied.count}</StatBadge>
                <StatBadge tone="green">{campaign.stats.interested.count}</StatBadge>
              </div>

              <div className="grid grid-cols-5 text-[10px] text-gray-400 mt-1 text-center">
                <span>Prospects</span>
                <span>Sent</span>
                <span>Open</span>
                <span>Reply</span>
                <span>Interested</span>
              </div>
            </div>
          ))
        )
        }
        </div>



        {/* Floating dropdown menu */}
        {openDropdown && (
          <div
            className="absolute z-50 bg-white shadow-xl rounded-lg border border-gray-200 w-40 overflow-hidden"
            style={{ top: dropdownPosition.top, left: dropdownPosition.left }}
          >
            <button
              onMouseDown={() => setSelectedCampaign(openDropdown)}
              className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50"
            >
              Summary
            </button>
            <button
              onMouseDown={() =>
                handleDetails(filteredCampaigns.find(c => c.id === openDropdown))
              }
              className="w-full px-4 py-2 text-left text-sm hover:bg-gray-50"
            >
              Details
            </button>
            <button
              onMouseDown={() => handleDelete(openDropdown)}
              className="w-full px-4 py-2 text-left text-sm text-red-600 hover:bg-red-50"
            >
              Delete
            </button>
          </div>
        )}

        {/* Summary Modal */}
        {selectedCampaign && (
          <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50">
            <CampaignSummary
              campaignId={selectedCampaign}
              onClose={() => setSelectedCampaign(null)}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default MyCampaign;
